import { FC, PropsWithChildren } from 'react';
import { User } from '@/api/rest';
import { useUser } from '@/common/hooks';

interface Props extends PropsWithChildren {
  for: NonNullable<User['agency_account_type']>[];
}

export const Feature: FC<Props> = ({ children, ...rest }) => {
  const { user } = useUser();
  const is_kakaostyle_account = user?.role === 'ZIGZAG';
  const is_access_granted = user?.agency_account_type && rest.for.includes(user.agency_account_type);
  if (is_kakaostyle_account || is_access_granted) {
    return children;
  }
  return null;
};
